import React from 'react';
import { Box, Typography } from '@mui/material';
import { SettingsTab } from '../../types/settings';
import { useUserContextController } from '../../context/UserContext';

interface SettingsSidebarProps {
  selectedTab: SettingsTab;
  onTabChange: (tab: SettingsTab) => void;
}

const SettingsSidebar: React.FC<SettingsSidebarProps> = ({
  selectedTab,
  onTabChange
}) => {
  const [userContext] = useUserContextController();

  return (
    <Box
      sx={{
        width: '150px',
        backgroundColor: 'white',
        borderRight: '1px solid #e0e0e0',
        padding: '16px'
      }}
    >
      <Typography
        variant="h6"
        sx={{
          marginBottom: '24px',
          paddingLeft: '8px',
          fontWeight: 600
        }}
      >
        Settings
      </Typography>

      {/* Navigation Items */}
      <Box
        onClick={() => onTabChange(SettingsTab.PROFILE)}
        sx={(theme) => ({
          padding: '12px 8px',
          borderRadius: '8px',
          cursor: 'pointer',
          backgroundColor:
            selectedTab === SettingsTab.PROFILE ? '#f0f7ff' : 'transparent',
          color:
            selectedTab === SettingsTab.PROFILE
              ? theme.customColors.themePrimary
              : 'text.primary',
          '&:hover': {
            backgroundColor:
              selectedTab === SettingsTab.PROFILE ? '#f0f7ff' : '#f5f5f5'
          }
        })}
      >
        <Typography>Profile</Typography>
      </Box>

      {userContext.user?.isBeta && (
        <>
          <Box
            onClick={() => onTabChange(SettingsTab.ACCESS)}
            sx={(theme) => ({
              padding: '12px 8px',
              borderRadius: '8px',
              cursor: 'pointer',
              marginTop: '8px',
              backgroundColor:
                selectedTab === SettingsTab.ACCESS ? '#f0f7ff' : 'transparent',
              color:
                selectedTab === SettingsTab.ACCESS
                  ? theme.customColors.themePrimary
                  : 'text.primary',
              '&:hover': {
                backgroundColor:
                  selectedTab === SettingsTab.ACCESS ? '#f0f7ff' : '#f5f5f5'
              }
            })}
          >
            <Typography>Access Control</Typography>
          </Box>
        </>
      )}

      {userContext.user?.isAdmin && (
        <Box
          onClick={() => onTabChange(SettingsTab.INTEGRATIONS)}
          sx={(theme) => ({
            padding: '12px 8px',
            borderRadius: '8px',
            cursor: 'pointer',
            marginTop: '8px',
            backgroundColor:
              selectedTab === SettingsTab.INTEGRATIONS
                ? '#f0f7ff'
                : 'transparent',
            color:
              selectedTab === SettingsTab.INTEGRATIONS
                ? theme.customColors.themePrimary
                : 'text.primary',
            '&:hover': {
              backgroundColor:
                selectedTab === SettingsTab.INTEGRATIONS ? '#f0f7ff' : '#f5f5f5'
            }
          })}
        >
          <Typography>Integrations</Typography>
        </Box>
      )}

      <Box
        onClick={() => onTabChange(SettingsTab.USAGE)}
        sx={(theme) => ({
          padding: '12px 8px',
          borderRadius: '8px',
          cursor: 'pointer',
          marginTop: '8px',
          backgroundColor:
            selectedTab === SettingsTab.USAGE ? '#f0f7ff' : 'transparent',
          color:
            selectedTab === SettingsTab.USAGE
              ? theme.customColors.themePrimary
              : 'text.primary',
          '&:hover': {
            backgroundColor:
              selectedTab === SettingsTab.USAGE ? '#f0f7ff' : '#f5f5f5'
          }
        })}
      >
        <Typography>Usage</Typography>
      </Box>
    </Box>
  );
};

export default SettingsSidebar;
